var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.value
        ? _c("ModalFullScreen", {
            on: { close: _vm.handleClose },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "px-2" }, [
                        _c("div", { staticClass: "cancel-modal-header" }, [
                          _c(
                            "div",
                            { staticClass: "info-icon" },
                            [_c("InfoIcon")],
                            1
                          ),
                          _c("h3", [_vm._v("Cancel Invoice")]),
                        ]),
                      ]),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "font-outfit cancel-modal-content-wrap",
                        },
                        [
                          _c("div", { staticClass: "info-text-holder" }, [
                            _c("p", [
                              _vm._v(
                                " By cancelling this invoice, you confirm that you want to nullify the transaction. "
                              ),
                            ]),
                            _c("p", [_vm._v("This action cannot be undone.")]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "btns-wrap flex gap-2 justify-end" },
                            [
                              _c("UiButton", {
                                attrs: {
                                  id: "cancelMessage",
                                  buttonText: "Not Now",
                                  variant: "outline",
                                },
                                on: { click: _vm.handleClose },
                              }),
                              _c("UiButton", {
                                attrs: {
                                  buttonText: "Confirm",
                                  id: "connfirm",
                                  buttonClass: "bg-black",
                                },
                                on: { click: _vm.cancelInvoice },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2208115748
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }